import _ from 'lodash';

import ExternalCustomerLookupGatewayObserver from './external_customer_lookup_gateway_observer';
import { ExternalCustomerLookupResult, LookupLevel } from 'models/external_customer_profile';
import { ExternalCustomerLookupStatusValue } from 'models/external_customer_lookup_status';
import { trimAndRemoveEmptyQueryFields } from './lib/lookup_helpers';

export default class {
  constructor(context) {
    this.context = context;
  }

  run(customerId) {
    requestCustomerAutoExtension(this.context, customerId);
    requestExternalCustomerSuggestions(this.context, customerId);
  }
}

export function requestCustomerAutoExtension(context, customerId) {
  let lookupStatus = context.stores.externalCustomerLookupStatus.get();
  if (
    lookupStatus &&
    (lookupStatus.status !== ExternalCustomerLookupStatusValue.OK || !lookupStatus.autoLinkingEnabled)
  ) {
    return;
  }

  // dont auto link if customer is already link or manually unlinked
  const customerStores = context.stores.customers.storesFor(customerId);
  const profile = customerStores.profile.get();
  if (!profile || profile.externalCustomerId || profile.unlinked) {
    return;
  }

  const { correlationId } = context.gateways.customerAutoExtension.update(customerId);

  const pendingLookupResult = new ExternalCustomerLookupResult({ customerId, id: correlationId });
  ExternalCustomerLookupGatewayObserver.setPendingSuggestionRequest(correlationId, pendingLookupResult);
}

export function requestExternalCustomerSuggestions(context, customerId) {
  let lookupStatus = context.stores.externalCustomerLookupStatus.get();
  if (lookupStatus.status !== ExternalCustomerLookupStatusValue.OK || lookupStatus.basicDisabled) {
    return;
  }

  if (!context.stores.customers.has({ id: customerId })) {
    return;
  }

  const customerStores = context.stores.customers.storesFor(customerId);
  const profile = customerStores.profile.get();
  // short circuit suggestion lookup if either of the below are satisfied:
  // 1. profile is already linked
  // 2. Auto linking is enabled and the profile has not been unlinked.
  if (
    !profile ||
    profile.externalCustomerId ||
    !_.isEmpty(profile.externalCustomerIds) ||
    (lookupStatus.autoLinkingEnabled && !profile.unlinked)
  ) {
    return;
  }

  let flattenedProfile = {
    ..._.pick(profile.toJs(), [
      'address',
      'emails',
      'externalCustomerId',
      'externalCustomerIds',
      'fbUserProfile',
      'image',
      'name',
      'phones',
      'twitter',
    ]),
    ...profile.customAttributes,
  };
  flattenedProfile.emails = getQueryContactList(flattenedProfile.emails, 'original');
  flattenedProfile.phones = getQueryContactList(flattenedProfile.phones, 'normalized');

  flattenedProfile = trimAndRemoveEmptyQueryFields(flattenedProfile);
  if (_.isEmpty(flattenedProfile)) {
    return;
  }

  flattenedProfile.id = profile.id;
  const { correlationId } = context.gateways.externalCustomerLookup.request({
    lookupLevel: LookupLevel.BASIC,
    query: flattenedProfile,
  });
  const pendingLookupResult = new ExternalCustomerLookupResult({ customerId, id: correlationId });
  ExternalCustomerLookupGatewayObserver.setPendingSuggestionRequest(correlationId, pendingLookupResult);
}

function getQueryContactList(attributes, takeAttr) {
  return _(attributes)
    .partition(attr => attr.primary)
    .flatten()
    .compact()
    .map(attr => attr[takeAttr])
    .value();
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/external_customer_lookup/lookup_customer.js